import { BOTONES } from '../../componentes/botones';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { CardHeaderComponent } from '../../componentes/card-header/card-header.component';

export interface ConfirmarActividadData {
  /** Segundos que tiene el operador para confirmar antes del escalado */
  segundosConfirmacion: number;
  /** Minutos de inactividad que dispararon el popup (solo para el mensaje) */
  minutosInactividad: number;
}

@Component({
  selector: 'app-confirmar-actividad-dialog',
  templateUrl: './confirmar-actividad-dialog.component.html',
  styleUrls: ['./confirmar-actividad-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    DecimalPipe,
    MatDialogModule,
    BOTONES,
    MatIconModule,
    MatProgressBarModule,
    MatCardModule,
    CardHeaderComponent,
  ],
})
export class ConfirmarActividadDialogComponent implements OnInit, OnDestroy {
  private matDialogRef =
    inject<MatDialogRef<ConfirmarActividadDialogComponent, boolean>>(
      MatDialogRef,
    );
  public data = inject<ConfirmarActividadData>(MAT_DIALOG_DATA);

  /** Emite una única vez cuando el countdown vence sin confirmación */
  @Output() escalado = new EventEmitter<void>();

  public segundosRestantes = this.data.segundosConfirmacion;
  public enEscalado = false;
  private interval?: NodeJS.Timeout;

  ngOnInit(): void {
    this.interval = setInterval(() => {
      this.segundosRestantes--;
      if (this.segundosRestantes <= 0) {
        clearInterval(this.interval!);
        this.enEscalado = true;
        this.escalado.emit();
      }
    }, 1_000);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval!);
  }

  public get progreso(): number {
    return (this.segundosRestantes / this.data.segundosConfirmacion) * 100;
  }

  public confirmar(): void {
    this.matDialogRef.close(true);
  }
}
